import { type LocationContent } from "@/components/location-page";
import { FEES, FIRM } from "@/lib/firm";

export const CONTENT: LocationContent = {
  slug: "dicky-beach",
  name: "Dicky Beach",
  title: "Dicky Beach conveyancing, wills and estates",
  metaTitle: `Dicky Beach Conveyancing & Wills Lawyers | ${FIRM.name}`,
  description: `Fixed-fee Dicky Beach conveyancing — sales ${FEES.sale} incl. GST, purchases ${FEES.purchase}. Wills, powers of attorney and estate administration. Call ${FIRM.phone}.`,
  lead: "Dicky Beach mixes original post-war cottages, renovated beach houses and a steady flow of unit sales close to the surf club. Prices are strong, which makes the five business day cooling-off period and the finance clause matter more, not less.",
  paragraphs: [
    "We act for Dicky Beach buyers and sellers on fixed fees from our Golden Beach office. Competitive pockets like this one attract short contract dates and pressure to sign quickly — we review contracts the same day wherever we can so you are not rushed into terms you have not read.",
    "Knock-down rebuilds are common here. If you are buying for the land, the planning search, easements and any character or coastal overlay are the searches that actually determine what you can build.",
    "For owners, the family home is usually the largest asset in the estate. A current will and an enduring power of attorney keep it out of dispute and let someone act for you if you cannot.",
  ],
  localNotes: [
    {
      t: "Fast-moving contracts",
      d: "Multiple-offer situations lead to short finance and inspection dates. We check the dates are achievable before you sign, not after.",
    },
    {
      t: "Buying for the land",
      d: "Demolition controls, setbacks, easements and stormwater all shape what a rebuild can look like. The searches answer this before the cooling-off period ends.",
    },
    {
      t: "Unit and townhouse purchases",
      d: "Disclosure statements, levies, sinking fund forecasts and by-laws on pets or short-term letting are reviewed as part of every unit purchase.",
    },
    {
      t: "Wills where property is the main asset",
      d: "Where the house is most of the estate, how it is gifted decides whether beneficiaries must sell. Worth structuring deliberately.",
    },
  ],
  suburbs: ["Shelly Beach", "Currimundi", "Moffat Beach", "Battery Hill", "Caloundra", "Aroona"],
  faqs: [
    {
      q: "How quickly can you review a Dicky Beach contract?",
      a: "Usually the same business day, and often within a few hours. Send the contract before you sign if you can — changes are far easier to negotiate at that point than during cooling-off.",
    },
    {
      q: "What is the cooling-off period in Queensland?",
      a: "Five business days from the day you receive a copy of the signed contract, unless you have waived it. Terminating during cooling-off costs 0.25% of the purchase price as a penalty.",
    },
    {
      q: "Do you handle deceased estates as well as the sale?",
      a: "Yes. We apply for probate or letters of administration, deal with the asset collection and distribution, and run any property sale within the estate on our fixed conveyancing fee.",
    },
  ],
};
